<template>
  <el-card class="card" shadow="never">
    <template #header>
      <div class="title">
        <span>{{ $t('Audiences_RollingSegment_Destination_Title') }}</span>
        <el-tooltip
          effect="light"
          :content="$t('Audiences_RollingSegment_Destination_Tooltip')"
          placement="top"
        >
          <span><i class="el-icon-warning-outline"/></span>
        </el-tooltip>
      </div>
    </template>
    <div>
      <slot></slot>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'LivingSegmentDestinationSection'
}
</script>

<style scoped>
.card {
  border: none;
}

>>> .el-card__header {
  border: 1px solid #ebeef5;
}

>>> .el-card__body {
  padding: 0;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4b515f;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/LivingSegmentDestinationSection.vue